<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>
              <v-icon>mdi-clipboard-text</v-icon>Print Product Label
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
              <v-btn text :to="'/products/view/' + this.id">
                <v-icon>mdi-arrow-left</v-icon>Back
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <pdf-viewer
            url="products/printLabel"
            :params="{ id }"
            :filename="this.filename"
            style="width: 300%"
          ></pdf-viewer>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PdfViewer from "@components/PdfViewer.vue";
export default {
  components: {
    PdfViewer
  },
  data() {
    return {
      id: this.$route.params.id,
      model: null
    };
  },
  computed: {
    filename: function() {
      return "product_"+this.id
    }
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      //this.getOrder(this.id);
    } else {
      this.$route.push("/products");
    }
  },
  methods: {
  }
};
</script>

<style></style>
